/**
 * Return Status Enum
 *
 * Values synced with backend ReturnStatusEnum.
 * @see backend/src/backend/db/constants/return_status.py
 *
 * Backend values:
 * - PENDING = 1
 * - COMPLETED = 2
 * - CANCELED = 3
 * - COLLECTED = 4
 */
import { intl } from "dmsbasereact";

// Static enum values for comparisons
export const ReturnStatusEnum = {
    PENDING: 1,
    COMPLETED: 2,
    CANCELED: 3,
    COLLECTED: 4,
};

export const ReturnStatus = {
    getText: (code) => {
        switch (code) {
            case ReturnStatusEnum.PENDING:
                return intl.get("Pending").d("Pending");
            case ReturnStatusEnum.COMPLETED:
                return intl.get("Completed").d("Completed");
            case ReturnStatusEnum.CANCELED:
                return intl.get("Canceled").d("Canceled");
            case ReturnStatusEnum.COLLECTED:
                return intl.get("Collected").d("Collected");
            default:
                return intl.get("Unknown").d("Unknown");
        }
    },
    getColor: (code) => {
        switch (code) {
            case ReturnStatusEnum.PENDING:
                return "warning";
            case ReturnStatusEnum.COMPLETED:
                return "success";
            case ReturnStatusEnum.CANCELED:
                return "error";
            case ReturnStatusEnum.COLLECTED:
                return "info";
            default:
                return "default";
        }
    }
};

/**
 * Get return status map (value -> label)
 * @returns {Object} Map of status value to label
 */
export const getReturnStatusMap = () => ({
    [ReturnStatusEnum.PENDING]: ReturnStatus.getText(ReturnStatusEnum.PENDING),
    [ReturnStatusEnum.COMPLETED]: ReturnStatus.getText(ReturnStatusEnum.COMPLETED),
    [ReturnStatusEnum.CANCELED]: ReturnStatus.getText(ReturnStatusEnum.CANCELED),
    [ReturnStatusEnum.COLLECTED]: ReturnStatus.getText(ReturnStatusEnum.COLLECTED),
});

// For backward compatibility - creates map lazily
export const ReturnStatusMap = new Proxy({}, {
    get: (_, prop) => {
        const numProp = Number(prop);
        if (!isNaN(numProp)) {
            return ReturnStatus.getText(numProp);
        }
        return undefined;
    }
});

/**
 * Get return status options for select components
 * @returns {Array} Array of {value, label} objects
 */
export const getReturnStatusOptions = () => [
    { value: ReturnStatusEnum.PENDING, label: ReturnStatus.getText(ReturnStatusEnum.PENDING) },
    { value: ReturnStatusEnum.COMPLETED, label: ReturnStatus.getText(ReturnStatusEnum.COMPLETED) },
    { value: ReturnStatusEnum.CANCELED, label: ReturnStatus.getText(ReturnStatusEnum.CANCELED) },
    { value: ReturnStatusEnum.COLLECTED, label: ReturnStatus.getText(ReturnStatusEnum.COLLECTED) },
];
